/* eslint-disable camelcase */
type SubmissionAlertProps = {
	className?: string
}

export default function SubmissionAlert({ className }: SubmissionAlertProps) {
	return (
		<div className={`flex items-center bg-bbx-spark/10 p-4 ${className}`}>
			<p className="text-sm text-center text-bbx-spark">
				Once you submit your selection, we&apos;ll start processing your order, and changes will no
				longer be possible
			</p>
		</div>
	)
}
